<template>
  <span>
    <v-btn
      @click="showAgencyModal = true"
      size="small"
      density="compact"
      variant="plain"
      icon="mdi-office-building"
      class="ml-2"
    >
    </v-btn>
    <v-dialog v-model="showAgencyModal" max-width="500px">
      <v-card>
        <v-card-title class="text-h5 bg-primary text-white">
          Switch Between Client Accounts
        </v-card-title>
        <v-card-text class="pa-0">
          <v-list bg-color="grey-lighten-4">
            <v-list-item
              v-for="account in getAuthCompanies"
              :key="account.id"
              :value="account.id"
              @click="handleAgencySelection(account.id)"
              :active="account.id === getAccountCompany"
              :active-color="'primary'"
              :bg-color="
                account.id === getAccountCompany ? 'primary-lighten-4' : ''
              "
              class="my-1 rounded mx-2"
              :prepend-icon="
                account.id === getAccountCompany
                  ? 'mdi-check-circle'
                  : 'mdi-office-building-outline'
              "
            >
              <v-list-item-title
                :class="
                  account.id === getAccountCompany ? 'font-weight-bold' : ''
                "
              >
                {{ account.name }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="pa-4 bg-grey-lighten-3">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            variant="elevated"
            @click="showAgencyModal = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import agencyService from 'src/services/agencyServices';

export default {
  name: 'GlobalAgencySelect',
  data() {
    return {
      showAgencyModal: false,
    };
  },
  computed: {
    ...mapGetters('auth', [
      'getAuthCompanies',
      'getCompanyName',
      'getLoginAccount',
      'getAccountCompany',
    ]),
  },
  methods: {
    async handleAgencySelection(companyId) {
      this.showAgencyModal = false;

      this.$loading({
        lock: true,
        text: 'Loading session',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.9)',
      });

      const id = +companyId;

      try {
        const r = await agencyService.simulateClient(id);
        this.$store.dispatch('auth/setAgency', r.data);

        // It should reroute to the overview page, not campaign listing.
        location.href = '/admin/overview';
      } catch (error) {
        this.$message({
          message: 'Error switching company',
          type: 'error',
          showClose: true,
        });
      }
    },
  },
};
</script>
